/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Avatar, Segmented, Tag } from "antd";
import { useSnackbar } from "notistack";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { format } from "date-fns";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CustomMaterialTable from "../../components/custom/CustomMaterialTable";
import {
  TextField,
  Typography,
  CardContent,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { AccessTime, CalendarToday } from "@mui/icons-material";
import utc from "dayjs/plugin/utc";
import { useMaterialUIController } from "context";
import Loader from "components/custom/Loader";
import timezone from "dayjs/plugin/timezone";
import "./notification.css";
import { ReactComponent as Usergroupicon } from "../../assets/images/icons/usergroup.svg";
import { ReactComponent as NotificationIcon } from "../../assets/images/icons/usernotification.svg";
import useApiRequest from "utils/Apirequest";
import { AutoTooltip } from "utils/Constant";
import { convertUTCtoDubai } from "utils/Constant";
import { getDecodedUserData } from "utils/Constant";

dayjs.extend(utc);
dayjs.extend(timezone);

function Emailnoti() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { sidenavColor } = controller;
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading1, setIsLoading1] = useState(true);
  const [columns, setColumns] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [selectedVal, setSelectedVal] = useState("allUser");
  const [subject, setSubject] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const dateFormat = "YYYY-MM-DD HH:mm";
  const [preview, setPreview] = useState(false);
  const [visibile, setVisibile] = useState(true);
  const [schedule, setSchedule] = useState(false);
  const [rows, setRows] = useState([]);
  const [rows1, setRows1] = useState([]);
  const navigate = useNavigate();
  const apiRequest = useApiRequest();
  useEffect(() => {
    setColumns(column);
  }, []);
  const statusList = ["Failed", "Sent"];
  const statusList1 = ["Failed", "Scheduled"];
  const handleDelete = async (row_data) => {
    const { data } =
      (await apiRequest(
        "delete",
        "email/" + row_data._id,
        null,
        {},
        {
          "Content-Type": "application/json",
        }
      )) || {};
    if (data?.status === true) {
      window.location.reload();
    }
  };

  const convertSchedule = (utcDate) => {
    if (!utcDate) return "N/A";

    const cronRegex = /^(\d{1,2}) (\d{1,2}) (\d{1,2}) (\d{1,2}) \*$/;
    const match = utcDate.match(cronRegex);

    if (!match) return "N/A";

    const [minute, hour, day, month] = match.map(Number);

    const year = new Date().getFullYear();

    const date = new Date(Date.UTC(year, month - 1, day, hour, minute));

    return format(date, "d'th' MMMM HH:mm");
  };
  const handleView = (row_data) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (visibile) {
      setPreview(true);
      setSubject(row_data.subject);
      setEmail(row_data.email);
      setDescription(row_data.description);
    } else {
      setSubject("");
      setEmail("");
      setDescription("");
    }
    setVisibile(!visibile);
  };
  const column = [
    {
      header: "Status",
      filterVariant: "select",
      filterSelectOptions: statusList,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "status",
      align: "center",
      fixed: "true",
      Cell: (row) => (
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          borderRadius="md"
          bgcolor="rgba(25, 128, 56, 0.2)"
          style={{
            flex: 1,
          }}
        >
          <Tag
            color={
              row.row.original.status === "Failed"
                ? "red"
                : row.row.original.status === "Pending"
                  ? "default"
                  : row.row.original.status === "Scheduled"
                    ? "yellow"
                    : row.row.original.status === "Sent"
                      ? "green"
                      : "yellow"
            }
          >
            {row.row.original.status}
          </Tag>
        </MDBox>
      ),
    },
    {
      header: "Subject", muiTableHeadCellProps: {
        align: 'center',
      },
      muiTableBodyCellProps: {
        align: 'center',
      }, accessorKey: "subject", align: "center",
      Cell: ({ cell }) => {
        const subject = cell.getValue() || ' ';
        return <AutoTooltip maxWidth={150}>{subject}</AutoTooltip>;
      }
    },
    {
      header: "Description", muiTableHeadCellProps: {
        align: 'center',
      },
      muiTableBodyCellProps: {
        align: 'justify',
      }, accessorKey: "description", align: "center",
      Cell: ({ cell }) => {
        const description = cell.getValue() || ' ';
        return <AutoTooltip maxWidth={150}>{description}</AutoTooltip>;
      }
    },
    {
      header: "Sent to", muiTableHeadCellProps: {
        align: 'center',
      },
      muiTableBodyCellProps: {
        align: 'center',
      }, accessorKey: "type", align: "center"
    },
    {
      header: "Created By", muiTableHeadCellProps: {
        align: 'center',
      },
      muiTableBodyCellProps: {
        align: 'center',
      }, accessorKey: "userId.username", align: "center"
    },
    {
      header: "Sent Date & Time", accessorKey: "updatedAt", align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      header: "Description",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "justify",
      },
      accessorKey: "description",
      align: "center",
    },
    {
      header: "Sent to",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "type",
      align: "center",
    },
    {
      header: "Created By",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "userId.username",
      align: "center",
    },
    {
      header: "Sent Date & Time",
      accessorKey: "updatedAt",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ cell }) => {
        return convertUTCtoDubai(cell.getValue());
      },
    },
    {
      header: "Created Date & Time",
      accessorKey: "createdAt",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ cell }) => {
          return convertUTCtoDubai(cell.getValue());
      },
    },
  ];
  const column1 = [
    {
      header: "Status",
      filterVariant: "select",
      filterSelectOptions: statusList1,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "status",
      align: "center",
      fixed: "true",
      Cell: (row) => (
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          borderRadius="md"
          bgcolor="rgba(25, 128, 56, 0.2)"
          style={{
            flex: 1,
          }}
        >
          <Tag
            color={
              row.row.original.status === "Failed"
                ? "red"
                : row.row.original.status === "Pending"
                  ? "default"
                  : row.row.original.status === "Scheduled"
                    ? "yellow"
                    : row.row.original.status === "Sent"
                      ? "green"
                      : "yellow"
            }
          >
            {row.row.original.status}
          </Tag>
        </MDBox>
      ),
    },
    {
      header: "Subject",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "subject",
      align: "center",
    },
    {
      header: "Description",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "justify",
      },
      accessorKey: "description",
      align: "center",
    },
    {
      header: "Schedule Date",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "scheduleTime",
      align: "center",
      Cell: ({ cell }) => {
        return convertSchedule(cell.getValue());
      },
    },
    {
      header: "Sent to",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "type",
      align: "center",
    },
    {
      header: "Created By",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "userId.username",
      align: "center",
    },
    {
      header: "Created Date & Time",
      accessorKey: "createdAt",
      align: "center",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ cell }) => {
        return convertUTCtoDubai(cell.getValue());
      },
    },
    {
      header: "Action",
      enableColumnFilter: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "action",
      align: "center",
      Cell: (row) =>
        row.row.depth === 0 ? (
          <div
            style={{
              position: "sticky",
              right: "0",
              zIndex: "111",
            }}
          >
            <Tooltip title={visibile ? "Show Preview" : "Hide Preview"} arrow>
              <MDButton
                onClick={(e) => handleView(row.row.original)}
                variant="gradient"
                color={visibile ? "info" : "success"}
                iconOnly
              >
                {visibile ? <VisibilityIcon /> : <VisibilityOffIcon />}
              </MDButton>
            </Tooltip>
            <Tooltip title="Delete" arrow>
              <MDButton
                sx={{
                  marginLeft: 2,
                }}
                onClick={(e) => handleDelete(row.row.original)}
                variant="gradient"
                color="error"
                iconOnly
              >
                <DeleteIcon />
              </MDButton>
            </Tooltip>
          </div>
        ) : null,
    },
  ];
  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }
    (async () => {
      const { data } =
        (await apiRequest(
          "get",
          "email/scheduled",
          null,
          {},
          { },
          false
        )) || {};
      if (data?.status === true) {
        setRows(data.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    })();
    (async () => {
      const { data } =
        (await apiRequest(
          "get",
          "email",
          null,
          {},
          { },
          false
        )) || {};
      if (data?.status === true) {
        setRows1(data.data);
        setIsLoading1(false);
      } else {
        setIsLoading1(false);
      }
    })();
  }, []);
  const createUser = async (subject, description, email) => {
    let payload;
    if (schedule) {
      const scheduleDate = dayjs(selectedDate).utc().format("m H D M *");
      payload = {
        subject: subject,
        description: description,
        email: email,
        scheduleTime: scheduleDate,
      };
    } else {
      payload = {
        subject: subject,
        description: description,
        email: email,
      };
    }


    const { data } =
      (await apiRequest(
        "POST",
        `email/${schedule ? "schedule-email" : selectedVal === "singleUser" ? "" : "send-email-to-all"}`,
        payload,
        {},
        { "Content-Type": "application/json" }
      )) || {};
    if (data?.status === true) {
      setSubject("");
      setDescription("");
      setEmail("");
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    if (subject === "" || description === "") {
      return enqueueSnackbar("All fields are necessary", { variant: "error" });
    }
    if (selectedVal === "singleUser" && email === "") {
      return enqueueSnackbar("All fields are necessary", { variant: "error" });
    }
    createUser(subject, description, email);
  };

  return (
    <MDBox mt={2} mb={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <Card
            variant="outlined"
            style={{
              padding: "8px",
            }}
          >
            <CardContent>
              <MDTypography variant="h6" mb={2}>
                Send Email
              </MDTypography>
              <div className="mobileNumber">
                <Segmented
                  options={[
                    {
                      label: (
                        <div
                          style={{
                            padding: 4,
                          }}
                        >
                          <Avatar
                            style={{
                              backgroundColor: "transparent", // Remove the background color
                              width: "4.5rem",
                            }}
                            icon={
                              <Usergroupicon
                                style={{}}
                                className={darkMode ? "usergroup-icon" : ""}
                              />
                            }
                          />
                          <div> All user</div>
                        </div>
                      ),
                      value: "allUser",
                    },
                    {
                      label: (
                        <div
                          style={{
                            padding: 4,
                          }}
                        >
                          <Avatar
                            style={{
                              backgroundColor: "transparent", // Remove the background color
                            }}
                            icon={
                              <NotificationIcon
                                style={{}}
                                className={darkMode ? "usergroup-icon" : ""}
                              />
                            }
                          />
                          <div>Single User</div>
                        </div>
                      ),
                      value: "singleUser",
                    },
                  ]}
                  onChange={(value) => {
                    setSelectedVal(value);
                  }}
                  style={{
                    marginBottom: "1.2rem",
                    backgroundColor: darkMode ? "#202940" : "#f5f5f5",
                    color: darkMode ? "#fff" : "#000",
                  }}
                />
                {selectedVal === "singleUser" ? (
                  <TextField
                    type="email"
                    label="Email"
                    placeholder="Enter Email"
                    value={email}
                    margin="normal"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                ) : null}
              </div>
              <TextField
                fullWidth
                label="Subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                margin="normal"
              />
              <TextField
                fullWidth
                label="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                margin="normal"
                multiline
                rows={8}
              />

              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item>
                  <MDButton
                    variant={schedule ? "outlined" : "contained"}
                    color={sidenavColor}
                    startIcon={<AccessTime />}
                    onClick={() => setSchedule(false)}
                  >
                    Now
                  </MDButton>
                </Grid>
                <Grid item>
                  <MDButton
                    variant={schedule ? "contained" : "outlined"}
                    color={sidenavColor}
                    startIcon={<CalendarToday />}
                    onClick={() => setSchedule(true)}
                  >
                    Schedule
                  </MDButton>
                </Grid>
                <Grid item>
                  {schedule && (
                    <DatePicker
                      variant="filled"
                      showTime={{
                        format: "HH:mm",
                      }}
                      defaultValue={dayjs(selectedDate, dateFormat)}
                      onChange={(date) => setSelectedDate(date)}
                    />
                  )}
                </Grid>
              </Grid>

              <FormControlLabel
                control={
                  <Switch
                    checked={preview}
                    onChange={() => setPreview(!preview)}
                  />
                }
                label="Preview"
                sx={{ mt: 2 }}
              />

              <MDButton
                variant="gradient"
                color="success"
                onClick={handleSubmit}
                sx={{ mt: 2 }}
              >
                Submit
              </MDButton>
            </CardContent>
          </Card>
        </Grid>

        {preview && (
          <Grid item xs={12} md={4}>
            <Card variant="outlined" sx={{}}>
              <CardContent>
                <Typography variant="h6">Preview</Typography>
                <MDBox
                  sx={{
                    textAlign: "center",
                    mb: 2,
                  }}
                >
                  <Typography variant="subtitle1">iOS</Typography>
                  <MDBox
                    sx={{
                      position: "relative",
                      width: 234,
                      height: 240,
                      backgroundImage: `url(/notificationImg/iphone2.png)`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      mx: "auto",
                    }}
                  >
                    <MDBox
                      sx={{
                        position: "absolute",
                        bottom: "10%",
                        left: "4%",
                        width: "92%",
                        display: "flex",
                        backgroundColor: "rgba(255, 255, 255, 0.75)",
                        borderRadius: 2,
                        p: 1,
                      }}
                    >
                      <MDBox
                        component="img"
                        src="/mm.png"
                        alt="Logo"
                        sx={{
                          width: 24,
                          height: 24,
                          mr: 1,
                          mt: 0.5,
                        }}
                      />

                      <MDBox
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          textAlign: "left",
                        }}
                      >
                        <MDTypography
                          variant="h6"
                          fontWeight="400"
                          fontSize="0.8rem"
                          lineHeight="18px"
                          sx={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 1,
                            overflow: "hidden",
                          }}
                          style={{ color: "#344767" }}
                        >
                          {subject ? subject : "No title"}
                        </MDTypography>
                        <MDTypography
                          variant="body"
                          fontSize="0.7rem"
                          lineHeight="14px"
                          sx={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 3,
                            overflow: "hidden",
                          }}
                          style={{ color: "#344767" }}
                        >
                          {description ? description : "No description"}
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
                <MDBox
                  sx={{
                    textAlign: "center",
                    mb: 2,
                  }}
                >
                  <Typography variant="subtitle1">Android</Typography>
                  <MDBox
                    sx={{
                      position: "relative",
                      width: 234,
                      height: 240,
                      backgroundImage: `url(/notificationImg/android1.png)`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      mx: "auto",
                    }}
                  >
                    <MDBox
                      sx={{
                        position: "absolute",
                        bottom: "10%",
                        left: "4%",
                        width: "92%",
                        display: "flex",
                        backgroundColor: "rgba(255, 255, 255, 0.75)",
                        borderRadius: 2,
                        p: 1,
                      }}
                    >
                      <MDBox
                        component="img"
                        src="/mm.png"
                        alt="Logo"
                        sx={{
                          width: 24,
                          height: 24,
                          mr: 1,
                          mt: 0.5,
                        }}
                      />

                      <MDBox
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          textAlign: "left",
                        }}
                      >
                        <MDTypography
                          variant="h6"
                          fontWeight="400"
                          fontSize="0.8rem"
                          lineHeight="18px"
                          sx={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 1,
                            overflow: "hidden",
                          }}
                          style={{ color: "#344767" }}
                        >
                          {subject ? subject : "No title"}
                        </MDTypography>
                        <MDTypography
                          variant="body"
                          fontSize="0.7rem"
                          lineHeight="14px"
                          sx={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 3,
                            overflow: "hidden",
                          }}
                          style={{ color: "#344767" }}
                        >
                          {description ? description : "No description"}
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
      <MDBox mt={6}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={1}
            px={2}
            variant="gradient"
            bgColor={sidenavColor}
            borderRadius="lg"
            coloredShadow={sidenavColor}
          >
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <MDTypography variant="h6" color="white">
                Schedule Email
              </MDTypography>
            </Grid>
          </MDBox>
          {isLoading ? (
            <Loader />
          ) : (
            <CustomMaterialTable
              columns={column1}
              data={rows}
              darkMode={darkMode}
              toggleDensity={false}
            />
          )}
        </Card>
      </MDBox>
      <MDBox mt={6}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={1}
            px={2}
            variant="gradient"
            bgColor={sidenavColor}
            borderRadius="lg"
            coloredShadow={sidenavColor}
          >
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <MDTypography variant="h6" color="white">
                History
              </MDTypography>
            </Grid>
          </MDBox>
          {isLoading1 ? (
            <Loader />
          ) : (
            <CustomMaterialTable
              columns={columns}
              data={rows1}
              darkMode={darkMode}
              toggleDensity={false}
            />
          )}
        </Card>
      </MDBox>
    </MDBox>
  );
}

export default Emailnoti;
